<template>
  <div class="blog-card-wrap">
    <div class="blog-card-container">
      <a class="card-link" :href="blogLink">
        <article class="blog-card">
          <img class="post-image" :src="imageSrc" :alt="imageAlt"/>
          <div class="article-details">
            <h4 class="post-category">{{ category }}</h4>
            <h3 class="post-title">{{ name }}</h3>
            <p class="post-description">{{ desc }}</p>
            <p class="post-author">{{ date }}</p>
          </div>
        </article>
      </a>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      name: {
        type: String,
        required: true
      },
      category: {
        type: String,
        required: true
      },
      image: {
        type: String,
        required: true
      },
      desc: {
        type: String,
        required: true
      },
      date: {
        type: String,
        required: true
      },
      blogLink: {
        type: String,
        required: true
      }
    },
    methods: {},
    computed: {
        imageSrc: function () {
            return require('./../../assets/imgs/' + this.image);
        },
        imageAlt: function () {
            return this.name + ' | American Credit';
        }
    }
  }
</script>
<style lang="scss">

  $bg: #eedfcc;
  $text: #777;
  $black: #121212;
  $white: #fff;
  $red: #e04f62;
  $border: #ebebeb;
  $shadow: rgba(0, 0, 0, 0.2);

  @mixin transition($args...) {
    transition: $args;
  }

  .blog-card-wrap {
    display: flex;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    color: $text;
    // background: $bg;
    font-size: 0.9375rem;
    // min-height: 100vh;
    margin: 0;
    line-height: 1.6;
    align-items: center;
    justify-content: center;
    text-rendering: optimizeLegibility;
    padding: 3rem;
    border-bottom: 1px solid #e2e5ea;
  }

  .blog-card-container {
    width: 60rem;
    height: 15rem;
  }

  .blog-card {
    display: flex;
    flex-direction: row;
    background: $white;
    box-shadow: 0 0.1875rem 1.5rem $shadow;
    border-radius: 0.375rem;
    overflow: hidden;
  }

  .card-link {
    position: relative;
    display: block;
    color: inherit;
    text-decoration: none;
    &:hover .post-title {
      @include transition(color 0.3s ease);
      color: $red;
    }
    &:hover .post-image {
      @include transition(opacity 0.3s ease);
      opacity: 0.9;
    }
  }

  .post-image {
    @include transition(opacity 0.3s ease);
    display: block;
    width: 100%;
    object-fit: cover;
  }

  .article-details {
    padding: 1.5rem;
  }

  .post-category {
    color: #007bff;
    display: inline-block;
    text-transform: uppercase;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.0625rem;
    margin: 0 0 0.75rem 0;
    padding: 0 0 0.25rem 0;
    border-bottom: 0.125rem solid $border;
  }

  .post-title {
    @include transition(color 0.3s ease);
    font-size: 1.125rem;
    line-height: 1.4;
    color: $black;
    font-weight: 700;
    margin: 0 0 0.5rem 0;
  }

  .post-author {
    color: #007bff;
    font-size: 0.875rem;
    line-height: 1;
    margin: 1.125rem 0 0 0;
    padding: 1.125rem 0 0 0;
    border-top: 0.0625rem solid $border;
  }

  @media (max-width: 40rem) {
    .blog-card-container {
      width: 25rem;
      height: 30rem;
    }
    
    .blog-card {
      flex-wrap: wrap;
    }
  }

  @supports (display: grid) {
    .blog-card-wrap {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 0.625rem;
      grid-template-areas: ". main main ." ". main main .";
    }
    
    .blog-card-container {
      grid-area: main;
      align-self: center;
      justify-self: center;
    }

    .post-image {
      height: 100%;
    }
    
    .blog-card {
      display: grid;
      grid-template-columns: 1fr 2fr;
      grid-template-rows: 1fr;
    }
    
    @media (max-width: 40rem) {
      .blog-card {
        grid-template-columns: auto;
        grid-template-rows: 12rem 1fr;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// BlogCard.vue?80c6c1c2